import { useEffect, useState } from "react";
import image1 from "../../Assets/images/create-assistant-img01.jpg";
import image2 from "../../Assets/images/create-assistant-img02.jpg";
import image3 from "../../Assets/images/create-assistant-img03.jpg";
import image4 from "../../Assets/images/create-assistant-img04.jpg";
import defaultImage from "../../Assets/images/default-profile-img.png";
import { AddAssistantImage } from "./AddAssistantImage";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getTemplateList } from "../../Redux/Slice/Assistant/GetTemplateListSlice";
export const CreateAssistantPopup = (props) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [addAssistant, setAddAssistant] = useState(false);
  const [seletedTemplate, setTemplate] = useState("");
  const [templateList, setTemplateList] = useState([]);
  const [selectedAssitant, setSelectedAssistant] = useState({
    image: defaultImage,
    name: "",
  });

  useEffect(() => {
    getTemplates();
  }, []);

  const Templates = useSelector((state) => state.templateList.templatesList);
  useEffect(() => {
    if (Templates) {
      setTemplateList(Templates.data);
    }
  }, [Templates]);

  const getTemplates = async () => {
    const result = await dispatch(getTemplateList());
  };
  const popUpClose = (isFromSubmit) => {
    props.setPopUp(false, isFromSubmit);
  };
  return (
    <>
      {addAssistant ? (
        <AddAssistantImage
          closePopup={popUpClose}
          selectedTemplate={seletedTemplate}
        />
      ) : (
        <div className="modal modal--createAssistant modal--open">
          <div className="modal__dialog">
            <div className="modal__content modal__content--lg">
              <div className="modal__header">
                <h1 className="modal__header--title">Create Assistant</h1>
                <p className="para">Here are few templates to get started</p>
                <button
                  className="btn btn__transparent btnClose"
                  onClick={() => {
                    props.setPopUp(false);
                  }}
                >
                  <svg
                    width="25"
                    height="24"
                    viewBox="0 0 25 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <rect
                      x="0.586914"
                      width="24"
                      height="24"
                      rx="12"
                      fill="#E5E5E5"
                    />
                    <path
                      d="M12.5869 10.8891L16.476 7L17.5869 8.11094L13.6979 12L17.5869 15.8891L16.476 17L12.5869 13.1109L8.69785 17L7.58691 15.8891L11.476 12L7.58691 8.11094L8.69785 7L12.5869 10.8891Z"
                      fill="#4F4F4F"
                    />
                  </svg>
                </button>
              </div>
              <div className="modal__body modal-body-left">
                <div className="createAssistant">
                  <div className="createAssistant__list">
                    {templateList
                      ? templateList.map((template) => (
                          <div className="createAssistant__item">
                            <label className="createAssistant__card">
                              <img
                                src={template?.avatar}
                                alt="Appointment Setter"
                                onClick={() => {
                                  const { ["id"]: omit, ...rest } = template;
                                  setTemplate(rest);
                                  setAddAssistant(true);
                                  // navigate("/add-assistant", {state:{selectedBot:"Appointment Setter"}})
                                }}
                              />
                            </label>
                            <h3 className="title title--primary">
                              {template.name}
                            </h3>
                          </div>
                        ))
                      : ""}

                    <div className="createAssistant__item">
                      <label className="createAssistant__card">
                        <svg
                          width="41"
                          height="41"
                          viewBox="0 0 41 41"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M20.5 3V38M3 20.5H38"
                            stroke="#1C1C1C"
                            stroke-opacity="0.28"
                            stroke-width="5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                        <input
                          id="uploadFile"
                          className="form__input"
                          onClick={() => {
                            // props.setPopUp(false);
                            setTemplate("");
                            setAddAssistant(true);
                          }}
                        />
                      </label>
                      <h3 className="title">Blank Template</h3>
                    </div>
                  </div>
                </div>
              </div>
              {/* <div className="modal__footer">
            <div className="btn__group">
              <button className="btn btn__white">Cancel</button>
              <button className="btn btn__primary">Continue</button>
            </div>
          </div> */}
            </div>
          </div>
          <div className="modal__backdrop"></div>
        </div>
      )}
    </>
  );
};
